<template>
  <div class="farerule-wrapper">
    <CModal
      :show.sync="isShow"
      :backdrop="true"
      :closeOnBackdrop="true"
      :centered="true"
      :size="'lg'"
      :color="'dark'"
      :title="$t('selFlightInfo.fareRules')"
      @update:show="onUpdateShow"
    >
    
<!--       
 <div v-html="fareRuleData[0].PricingInfo.fareRule.rule">
                  </div>  -->
                  <div v-if="sSearchObj.trip==2">
                     <CTabs variant="pills"  :activeTab="activeTabIndex" @update:activeTab="onUpdateTabIndex">
                        <CTab v-if="fareRuleData[0].Type!='RT'">
                        
                            <template v-if="fareRuleData[0].Type!='RT' && fareRuleData[1] && fareRuleData[1].obFlight" #title>
                              <span>
                                {{fareRuleData[1].obFlight[0].flight.DepAirport}} - {{fareRuleData[1].obFlight[fareRuleData[1].obFlight.length-1].flight.ArrAirport}}
                              </span>
                                
                            </template>
                           
                            
                            <div v-if="fareRuleData[1] && fareRuleData[1].PricingInfo &&
                             fareRuleData[1].PricingInfo.fareRule && fareRuleData[1].PricingInfo.fareRule.rule">
                          <div v-html="fareRuleData[1].PricingInfo.fareRule.rule">
                        </div>
                           </div>
                        </CTab>
                        <CTab v-if="fareRuleData[0].Type=='RT'">
                           <template v-if="fareRuleData[0].Type=='RT' && fareRuleData[0] && fareRuleData[0].obFlight" #title>
                              <span>
                                {{fareRuleData[0].obFlight[0].flight.DepAirport}} - {{fareRuleData[0].obFlight[fareRuleData[0].obFlight.length-1].flight.ArrAirport}}
                              </span>
                                
                            </template>
                            <div v-if="fareRuleData[0] && fareRuleData[0].PricingInfo &&
                             fareRuleData[0].PricingInfo.fareRule && fareRuleData[0].PricingInfo.fareRule.rule">
                          <div v-html="'Fare conditions for itinerary'+fareRuleData[0].PricingInfo.fareRule.rule.split('Fare conditions for itinerary')[1]">
                        </div>
                           </div>
                        </CTab>
                       
                        <CTab>
                          

                            <template v-if="fareRuleData[0] && fareRuleData[0].ibFlight" #title>
                              <div>
                                {{fareRuleData[0].ibFlight[0].flight.DepAirport}} - {{fareRuleData[0].ibFlight[fareRuleData[0].ibFlight.length-1].flight.ArrAirport}}
                              </div>
                                
                            </template>
                            <div v-if="fareRuleData[0].Type!='RT' &&fareRuleData[0] && fareRuleData[0].PricingInfo && 
                            fareRuleData[0].PricingInfo.fareRule && fareRuleData[0].PricingInfo.fareRule.rule">
                          <div v-html="fareRuleData[0].PricingInfo.fareRule.rule">
                        </div>
                           </div>
                            <div v-if="fareRuleData[0].Type=='RT' &&fareRuleData[0] && fareRuleData[0].PricingInfo && 
                            fareRuleData[0].PricingInfo.fareRule && fareRuleData[0].PricingInfo.fareRule.rule">
                          <div v-html="'Fare conditions for itinerary'+fareRuleData[0].PricingInfo.fareRule.rule.split('Fare conditions for itinerary')[2]">
                        </div>
                           </div>
                          
                        </CTab>
                        
                 </CTabs>
                  </div>
              <div v-if="sSearchObj.trip==3">
                  <CTabs variant="pills"  :activeTab="activeTabIndex" @update:activeTab="onUpdateTabIndex">
                        <CTab v-for="(fare,index) in fareRuleData" :key="index+'fare'">
                            <template v-if="fare.obFlight" #title>
                              <span>
                                {{fare.obFlight[0].flight.DepAirport}} - {{fare.obFlight[fare.obFlight.length-1].flight.ArrAirport}}
                              </span>
                                
                            </template>
                            
                            
                            <div v-if="fare && fare.PricingInfo && fare.PricingInfo.fareRule && fare.PricingInfo.fareRule.rule">
                          <div v-html="fare.PricingInfo.fareRule.rule">
                        </div>
                           </div>
                        </CTab>
                        
                 </CTabs>

              </div>
               <div v-if="sSearchObj.trip==1">
                  <CTabs variant="pills"  :activeTab="activeTabIndex" @update:activeTab="onUpdateTabIndex">
                         <CTab>
                            <template v-if="fareRuleData[0] && fareRuleData[0].obFlight" #title>
                              <span>
                                {{fareRuleData[0].obFlight[0].flight.DepAirport}} - {{fareRuleData[0].obFlight[fareRuleData[0].obFlight.length-1].flight.ArrAirport}}
                              </span>
                                
                            </template>
                            
                            
                            <div v-if="fareRuleData[0] && fareRuleData[0].PricingInfo &&
                             fareRuleData[0].PricingInfo.fareRule && fareRuleData[0].PricingInfo.fareRule.rule">
                          <div v-html="fareRuleData[0].PricingInfo.fareRule.rule">
                        </div>
                           </div>
                        </CTab>
                 </CTabs>

              </div>
  
   <template #header-wrapper>
        <div  class="d-flex justify-content-center">
          <template>
            <CCardHeader>
              <CRow col="12">
                <CCol col="9" class="title-icon">
                   <strong>{{$t('selFlightInfo.fareRules')}}</strong>
                   <!-- <a @click="buttonList[0].func" v-c-tooltip.hover="{
                      content: `New Tab`
                    }" class="c-pointer">
                      
                        <img src="@imgPath/img/svg/icons/new-tab.svg" alt="">
                    </a> -->
                </CCol>
                <CCol col="3" class="d-flex justify-content-end align-item-center">
                    <a @click="buttonList[0].func"  class="c-pointer">
                        <!--                    <CIcon-->
                        <!--                      class="w-100 justify-content-end"-->
                        <!--                      color="white"-->
                        <!--                      name="cil-chart-line"-->
                        <!--                      size="lg"-->
                        <!--                    />-->
                        <img src="@imgPath/img/svg/icons/cross.svg" alt="">
                    </a>
                  <!-- target="_blank" :href="externalLink" -->
                </CCol>
              </CRow>
            </CCardHeader>
          </template>
          <br />
          <br />
          <!-- </div> -->
        </div>
      
  </template>


      <template #footer-wrapper>
        <CCardBody class="d-flex justify-content-end">
          <CRow class="confirm-btn-wrapper">
            <CCol
              v-for="(button,index) in buttonList"
              :key="index"
              xl
              class="removewrap mb-3 mb-xl-0"
            >
              <CButton
                @click="button.func"
                :color="button.color"
                aria-pressed="true"
              >{{button.name}}</CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </template>
    </CModal>
  </div>
</template>

<script>
// import BaseConfiguration from "../../config/base";
import { onOpenLink } from "../../util/util.js";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
import Logger from '../../services/logger';
import { LOG_TYPE } from '../../config/API_DATA';
import BaseConfiguration from '../../config/base';
import {mapGetters, mapActions} from "vuex";
export default {
  name: COMPONENT_NAME.C_FARE_RULE,

  props: {
   
    show: {
      type: Boolean,
      default: false
    },
    
    

    buttonList: {
      type: Array,
      default: [
        {
          name: null,
          func: {
            type: Function
          },
          color: {
            type: String,
            default: "primary"
          }
        }
      ]
    },
     fareRuleData: null
  },
  watch: {
    show(val) {
      this.isShow = val;
    }
  },
   data: () => ({
     isShow:false,
     activeTabIndex:0
   }),

   computed: {
           DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
            ...mapGetters("sCMultiCitySearch", {
                sSearchObj: "GET_ML_SEARCH_OBJ",

            }),
            ...mapGetters("sCSearch", {
                
                sSearchObj: "GET_SEARCH_OBJ",
                
            })
        },
  methods: {
  onUpdateShow(value) {
      try {
        if(BaseConfiguration.isDebug) console.log("onUpdateShow");
       this.$emit('updateShow')
  
      } catch (err) {
              let body = Logger.buildRequest(
                COMPONENT_NAME.C_FARE_RULE,
                "error in onUpdateShow",
                err.toString(),
                "onUpdateShow",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        
      },
      
      onUpdateTabIndex(pTabIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onUpdateTabIndex");
                    this.activeTabIndex = pTabIndex;
                    } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_NEW,
                        "error in onUpdateTabIndex",
                        err.toString(),
                        "onUpdateTabIndex",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
    
  }, 
  created() {
    // this.isShow=this.show;
  }
};
</script>
<style scoped>
.tab-title {
   
    list-style: none;
}
.header-color {
  background: green;
}
.icon-color {
  color: white;
}
</style>
